import KeyValue from '../../../../../../../../../structures/keyValePair';
import { IMPORT_DESCRIPTOR_TYPES } from '../../../../../../constants/generalConstants';

export const TYPES = IMPORT_DESCRIPTOR_TYPES.map((t) => KeyValue.createSame(t));
